import { type FC } from 'react';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { type Prize, WHEEL_PRIZES } from '@/entities/wheel/model/wheel.types';

import { BoosterPlaycoinPrizeName } from './BoosterPlaycoinPrizeName';
import { BoosterXPPrizeName } from './BoosterXPPrizeName';
import { ClickerPrizeName } from './ClickerPrizeName';
import { CoinPrizeName } from './CoinPrizeName';
import { CommonPrizeName } from './CommonPrizeName';
import { PremiumPrizeName } from './PremiumPrizeName';
import { TicketPrizeName } from './TicketPrizeName';
import { type PrizeNameProps } from './types';

import s from './index.module.scss';

interface Props extends PrizeNameProps {
  className?: string;
  isLootbox?: boolean;
}

const PRIZE_NAME_BY_TYPE: Partial<Record<Prize['type'], FC<PrizeNameProps>>> = {
  [WHEEL_PRIZES.BOOSTER_PLAYCOIN]: BoosterPlaycoinPrizeName,
  [WHEEL_PRIZES.BOOSTER_XP]: BoosterXPPrizeName,
  [WHEEL_PRIZES.PREMIUM]: PremiumPrizeName,
  [WHEEL_PRIZES.TICKET]: TicketPrizeName,
  [WHEEL_PRIZES.PLAYCOIN]: CoinPrizeName,
  [WHEEL_PRIZES.NOT]: CoinPrizeName,
  [WHEEL_PRIZES.TON]: CoinPrizeName,
  [WHEEL_PRIZES.CLICKER_PLAYCOIN]: ClickerPrizeName,
  [WHEEL_PRIZES.CLICKER_XP]: ClickerPrizeName,
};

export const PrizeName: FC<Props> = ({ className, prize, isLootbox }) => {
  const { t } = useTranslation();

  const PrizeNameContent = PRIZE_NAME_BY_TYPE[prize.type] ?? CommonPrizeName;

  return (
    <div className={clsx(s.container, className)}>
      {isLootbox ? (
        <div className={s.name}>{t('Super Prize')}</div>
      ) : (
        <PrizeNameContent prize={prize} />
      )}
    </div>
  );
};
